<template>
  <div class="quote-list">
    <h3>订单管理</h3>

    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item label="甲方昵称">
        <el-input v-model="filter.partyAName" placeholder="甲方昵称"></el-input>
      </el-form-item>
      <el-form-item label="乙方昵称">
        <el-input v-model="filter.partyBName" placeholder="乙方昵称"></el-input>
      </el-form-item>

      <el-form-item label="合同编号">
        <el-input v-model="filter.contractId" placeholder="合同编号"></el-input>
      </el-form-item>

      <el-form-item label="合同类型">
        <el-select v-model="filter.type">
          <el-option label="全部" value=""></el-option>
          <el-option label="时薪" :value="1"></el-option>
          <el-option label="项目制" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手续费率">
        <div style="display:flex">
          <el-input-number v-model="filter.feeStart" controls-position="right" :min="0" :max="100" :precision="0"
            :step="1"></el-input-number>
          &nbsp;%~&nbsp;
          <el-input-number v-model="filter.feeEnd" controls-position="right" :min="0" :max="100" :precision="0"
            :step="1"></el-input-number>
          &nbsp;%
        </div>
      </el-form-item>

      <el-form-item label="异常状态">
        <el-select v-model="filter.applyForceStop">
          <el-option label="全部" value=""></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="订单类型">
        <el-select v-model="filter.sourceType">
          <el-option label="全部" value=""></el-option>
          <el-option label="职位" :value="1"></el-option>
          <el-option label="服务" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="创建时间从">
        <el-date-picker v-model="filter.createTimeStart" type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="filter.createTimeEnd" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="甲方手机号">
        <el-input v-model="filter.partyAPhone" placeholder="甲方手机号"></el-input>
      </el-form-item>
      <el-form-item label="乙方手机号">
        <el-input v-model="filter.partyBPhone" placeholder="乙方手机号"></el-input>
      </el-form-item>



      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="exportExcel" size="mini">导出</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>

    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="contractId" label="合同编号"></el-table-column>
      <el-table-column prop="contractTitle" label="合同名称">
        <template slot-scope="scope">
          {{ scope.row.contractTitle }}
        </template>
      </el-table-column>
      <el-table-column prop="sourceType" label="订单类型">
        <template slot-scope="scope">{{
          map.order.sourceType[scope.row.sourceType]
        }}</template>
      </el-table-column>
      <el-table-column prop="partyANickName" label="甲方名称"></el-table-column>
      <el-table-column width="120" prop="partyAPhoneNumber" label="甲方手机"></el-table-column>
      <el-table-column width="100" prop="vatRate" label="甲方增值税率">
        <template slot-scope="scope">{{
          scope.row.vatRate
        }}%</template>
      </el-table-column>

      <el-table-column prop="partyBNickName" label="乙方名称"></el-table-column>
      <el-table-column width="120" prop="partyBPhoneNumber" label="乙方手机"></el-table-column>
      <el-table-column prop="type" label="合同类型">
        <template slot-scope="scope">{{
          map.order.contractType[scope.row.type]
        }}</template>
      </el-table-column>
      <el-table-column prop="" label="合同金额">
        <template slot-scope="scope">
          <template v-if="scope.row.type === 1">{{ scope.row.monthlyRate }}元/月</template>
          <template v-else>{{ scope.row.totalAmount }}元</template>
        </template>
      </el-table-column>
      <el-table-column prop="fee" width="100px" label="乙方费率">
        <template slot-scope="scope">{{ scope.row.fee }}
          <span> %</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="工作状态">
        <template slot-scope="scope">{{
          map.order.workStatus[scope.row.orderStatus]
        }}</template>
      </el-table-column>
      <el-table-column prop="totalTime" label="工作总时长"></el-table-column>
      <el-table-column prop="" label="工作总价值">
        <template slot-scope="scope">
          <template v-if="scope.row.type">{{ scope.row.totalIncome }}</template>
          <template v-else>{{ scope.row.totalAmount }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="totalBalance" label="订单余额"></el-table-column>
      <el-table-column prop="vat" label="增值税金额">
        <template slot-scope="scope">
          <template>{{ scope.row.vat }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="" label="是否DCN">
        <template slot-scope="scope">
          <template>{{ scope.row.dcnStatus == 1 ? '是' : '否' }}</template>
        </template>
      </el-table-column>
      <el-table-column width="180" prop="orderCreateTime" label="创建时间"></el-table-column>
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="scope">
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{ action: 'stop', data: scope.row }" :disabled="!(scope.row.orderStatus !== 4 && scope.row.applyForceStop)
                ">结束工作
              </el-dropdown-item>
              <el-dropdown-item :command="{ action: 'workDetail', data: scope.row }">查看工作
              </el-dropdown-item>
              <el-dropdown-item :command="{ action: 'orderDetail', data: scope.row }">查看订单
              </el-dropdown-item>
              <el-dropdown-item v-if="scope.row.dcnStatus == 0" :command="{ action: 'addDcn', data: scope.row }">加入 DCN
              </el-dropdown-item>
              <el-dropdown-item v-if="scope.row.dcnStatus == 1" :command="{ action: 'removeDcn', data: scope.row }">移出
                DCN
              </el-dropdown-item>
              <el-dropdown-item :command="{ action: 'edit', data: scope.row }">修改订单
              </el-dropdown-item>
              <el-dropdown-item>
                <!-- <a
                  :href="`/msgs?sessionId=${scope.row.conversationId}`"
                  target="_blank"
                  >查看聊天</a
                > -->
                <span class="btn-text" @click="handleMsgs(scope.row)">
                  查看聊天
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <br />

    <div style="float: right">
      <el-pagination background layout="prev, pager, next" :current-page="pageNum"
        @current-change="(i) => (pageNum = i)" :page-size="limit" :total="total">
      </el-pagination>
    </div>

    <el-dialog title="是否确认结束工作？" :visible.sync="stopDialogShow">
      <p>申请结束理由：{{ curData.applyForceReason || "无" }}</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="stopDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="stopWork">确认结束</el-button>
      </div>
    </el-dialog>

    <el-dialog title="订单详情" :visible.sync="dialog.token" :fullscreen="true">
      <iframe :src="iframeUrl" width="100%" :height="iframeHeight" frameborder="0"></iframe>
    </el-dialog>

    <el-dialog title="修改订单信息" :visible.sync="dialog.detail">
      <el-form label-width="120px" :model="orderInfo" :rules="rules" ref="orderInfo">
        <template v-if="orderInfo.type === 1">
          <el-form-item label="时薪金额" prop="hourlyHour">
            <el-input type="text" v-model="orderInfo.hourlyHour" :disabled="true" />
          </el-form-item>
          <el-form-item label="每日工作时长" prop="workTimePerDay">
            <el-input type="text" v-model="orderInfo.workTimePerDay" @input="updatePage($event)" />
          </el-form-item>
          <el-form-item label="月薪金额" prop="monthlyRate" :disabled="true">
            <el-input type="text" v-model="orderInfo.monthlyRate" />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="项目金额" prop="totalAmount">
            <el-input type="text" v-model="orderInfo.totalAmount" :disabled="true" />
          </el-form-item>
          <el-form-item label="项目截止日" prop="projectDeadline">
            <el-date-picker v-model="orderInfo.projectDeadline" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="项目截止日" style="width: 100%"></el-date-picker>
          </el-form-item>
        </template>
        <el-form-item label="手续费率：" prop="fee">
          <el-input style="width: 200px" v-model.trim="orderInfo.fee" size="mini" placeholder="请输入手续费率"
            onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          <span> %</span>
        </el-form-item>
        <el-form-item label="工作内容">
          <el-input type="textarea" v-model="orderInfo.workStandard" :rows="5" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <!-- <el-button @click="toggleDialog('detail')">取消</el-button> -->
          <el-button @click="toDialog()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";

const { order } = api;

export default {
  name: "user-list",
  data() {
    return {
      filter: {
        contractId: "",
        createTimeStart: "",
        createTimeEnd: "",
        partyAName: "",
        partyBName: "",
        applyForceStop: "",
        partyAPhone: "",
        partyBPhone: "",
        sourceType: "",
        type: "",
        feeStart: 0,
        feeEnd: 100,
      },
      map,
      loading: true,
      list: [],
      total: 0,
      limit: 10,
      pageNum: 1,
      stopDialogShow: false,
      curData: {},
      dialog: {
        token: false,
        detail: false,
      },
      token: "",
      iframeUrl: "",
      orderInfo: {
        workTimePerDay: "",
        fee: 30,
      },
      rules: {
        fee: [
          {
            required: true,
            message: "请输入手续费率",
            trigger: "blur",
          },
        ],
        hourlyHour: [
          {
            required: true,
            message: "请输入时薪",
            trigger: "blur",
          },
        ],
        workTimePerDay: [
          {
            required: true,
            message: "请输入每日工作时长",
            trigger: "blur",
          },
        ],
        monthlyRate: [
          {
            required: true,
            message: "请输入月薪",
            trigger: "blur",
          },
        ],
        totalAmount: [
          {
            required: true,
            message: "请输入项目金额",
            trigger: "blur",
          },
        ],
        projectDeadline: [
          {
            required: true,
            message: "请输入项目截止时间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {},
  computed: {
    entityId() {
      return this.$route.query.entityId || this.$route.query.jid || "";
    },
    iframeHeight() {
      return window.innerHeight * 0.9;
    },
    publisherId() {
      return this.$route.query.publisherId;
    },
    cid() {
      return this.$route.query.cid || "";
    },
  },
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  created() {
    this.filter.contractId = this.cid;
  },
  methods: {
    updatePage() {
      this.$forceUpdate();
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        entityId: this.entityId,
        contractId: this.filter.contractId,
        createTimeStart: this.filter.createTimeStart,
        createTimeEnd: this.filter.createTimeEnd,
        partyAName: this.filter.partyAName,
        partyBName: this.filter.partyBName,
        publisherId: this.publisherId,
        applyForceStop: this.filter.applyForceStop,
        partyAPhone: this.filter.partyAPhone,
        partyBPhone: this.filter.partyBPhone,
        sourceType: this.filter.sourceType,
        type: this.filter.type,
        feeStart: this.filter.feeStart,
        feeEnd: this.filter.feeEnd,
      };

      let res = await order.list(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    showStopDialog(data) {
      this.stopDialogShow = !this.stopDialogShow;
      this.curData = data;
    },
    async stopWork() {
      let obj = {
        contractId: this.curData.contractId,
      };
      let res = await order.forceStopOrder(obj);
      if (res.data.code == 200) {
        this.$message.success("已结束工作");
        this.stopDialogShow = false;
        this.fetch();
      } else {
        this.$message.error(res.data.desc);
      }
    },
    toggleDialog(name, data) {
      this.dialog[name] = !this.dialog[name];
    },
    toDialog() {
      this.$refs.orderInfo.resetFields();
      this.dialog.detail = false;
    },
    async getToken(curData, name) {
      let obj = {
        contractId: curData.contractId,
      };
      let {
        data: { code, data },
      } = await order.token(obj);
      if (code == 200) {
        // this.token = token;
        if (name == "workDetail") {
          this.iframeUrl = `${this.frontUrl}/log/${curData.orderId}?encrypt_code=${data}`;
        } else {
          this.iframeUrl = `${this.frontUrl}/order/detail/${curData.orderId}?tab=contract&encrypt_code=${data}`;
        }

        window.open(this.iframeUrl, "_blank");
      }
    },
    async exportExcel() {
      this.loading = true;

      let obj = {
        entityId: this.entityId,
        contractId: this.filter.contractId,
        createTimeStart: this.filter.createTimeStart,
        createTimeEnd: this.filter.createTimeEnd,
        publisherId: this.publisherId,
      };
      let resp = await order.export(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      link.download = decodeURIComponent("订单列表.xls");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },

    submit() {
      this.$refs.orderInfo.validate((valid) => {
        if (valid) this.updateOrder();
      });
    },
    async updateOrder() {
      let {
        contractId,
        type,
        hourlyHour,
        weeklyLimit,
        workTimePerDay,
        monthlyRate,
        totalAmount,
        projectDeadline,
        workStandard,
        fee,
      } = this.orderInfo;
      let obj = {
        contractId,
        type,
        hourlyHour,
        weeklyLimit: workTimePerDay * 5,
        monthlyRate,
        totalAmount,
        projectDeadline,
        workStandard,
        fee: Number(this.orderInfo.fee),
      };

      let {
        data: { code, data },
      } = await order.update(obj);
      if (code == 200) {
        this.$message.success("修改成功！");
        this.toggleDialog("detail");
        this.fetch();
      } else {
        this.toggleDialog("detail");
        this.fetch();
      }
    },
    handleCommand(command) {
      let action = command.action;
      let data = command.data;
      switch (action) {
        case "stop":
          this.showStopDialog(data);
          break;
        case "workDetail":
          this.getToken(data, "workDetail");
          break;
        case "orderDetail":
          this.getToken(data, "orderDetail");
          break;
        case "addDcn":
          this.updateDcn(data, 1 );
          break;
        case "removeDcn":
          this.updateDcn(data, 0);
          break;

        case "edit":
          this.orderInfo = data;
          this.orderInfo.workTimePerDay = data.weeklyLimit / 5;
          this.toggleDialog("detail");
          break;
        default:
      }
    },
    async updateDcn(value, status) {
      let obj = {
        orderId: value.orderId,
        status: status,
      };
      let {
        data: { code, data },
      } = await order.updateDcn(obj);
      if (code == 200) {
        this.$message.success("修改成功！");
        this.fetch();
      } else {
        this.fetch();
      }
    },
    handleMsgs(row) {
      this.$router.push({
        path: "/msgs",
        query: {
          sessionId: row.conversationId,
          partyA: "",
          partyB: "",
        },
      });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
.order-list {}

.fon-tex-coll {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btn-text {
  color: #1ab394;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/order/orders.vue